
import * as ArticleConstants from '@/constants/ArticleCardsConstants';
export default {
  name: 'ProductListCategoryProducts',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    searchResult: {
      type: Object,
      default: () => {
      }
    },
    productListFamily: {
      type: Array,
      default: () => []
    },
    articles: {
      type: Array,
      default: () => []
    },
    articleIndexList: {
      type: Array,
      default: () => []
    },
    hasSpecialPrices: {
      type: Boolean,
      default: null
    },
    categoryTree: {
      type: Array,
      default: () => null
    }
  },
  data () {
    return {
      isMounted: false
    }
  },
  computed: {
    allowedNumberOfArticles () {
      ArticleConstants.PRODUCT_TO_ARTICLES_RATIO.forEach(ratio => {
        if (this.searchResult.data.items.length < ratio.PRODUCTS) {
          return ratio.ARTICLES
        }
      })
      return this.articleIndexList.length
    },
    mergedList () {
      const totalListIndex = this.searchResult.data.items.length + this.articleIndexList.length
      const mergedProductArticleList = []
      let productListIndex = 0
      let articleListIndex = 0
      for (let mergedListIndex = 0; mergedListIndex < totalListIndex; mergedListIndex++) {
        if (this.showArticleCard(mergedListIndex, articleListIndex)) {
          mergedProductArticleList.push({ isArticle: true, article: this.articles[articleListIndex] })
          articleListIndex += 1
        } else if (productListIndex < this.searchResult.data.items.length) {
          mergedProductArticleList.push({ isArticle: false, product: this.searchResult.data.items[productListIndex] })
          productListIndex += 1
        }
      }
      return mergedProductArticleList
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    showArticleCard (mergedListIndex, articleListIndex) {
      return this.articleIndexList.includes(mergedListIndex) && articleListIndex < this.allowedNumberOfArticles
    }
  }
}
